import { Home } from './Home';

export const PageStrings = {
  ...Home,
};
